import { Collection, ICollection } from 'firebase-firestorm'
import { BaseRepository } from '../Firestore/BaseRepository'
import { GLCodeProductCategory } from './GLCodeProductCategory'

export class GLCodeProductCategoryRepository extends BaseRepository<GLCodeProductCategory> {
  public async findByRestaurant(restaurantId: string) {
    const query = this.getCollection().query()
      .where('restaurantId', '==', restaurantId)
      .get()

    return ( await query ).docs
  }

  public async findByProductCategoryIdAndRestaurantId(productCategoryId: string, restaurantId: string) {
    const query = this.getCollection().query()
      .where('productCategoryId', '==', productCategoryId)
      .where('restaurantId', '==', restaurantId)
      .get()

    return ( await query ).docs
  }

  protected getCollection(): ICollection<GLCodeProductCategory> {
    return Collection(GLCodeProductCategory)
  }

  protected getNewInstance(): GLCodeProductCategory {
    return new GLCodeProductCategory()
  }
}
